import React, { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { APP_STORE_APP_URL, GOOGLE_PLAY_APP_URL } from '../../constants';
import { styles } from './styles';

type Props = HTMLAttributes<HTMLDivElement>;

export const MobileAppButtons: FC<Props> = (props) => {
  const [t] = useTranslation();
  return (
    <div css={styles} className='mobile-app-buttons' {...props}>
      <a href={APP_STORE_APP_URL} target='_blank' title={t('label.downloadAppOnAppStore')} className='mobile-app-button'>
        <img src='/images/ios-app-button.png' alt={t('label.downloadAppOnAppStore')} />
      </a>

      <a href={GOOGLE_PLAY_APP_URL} target='_blank' title={t('label.downloadAppOnGooglePlay')} className='mobile-app-button'>
        <img src='/images/android-app-button.png' alt={t('label.downloadAppOnGooglePlay')} />
      </a>
    </div>
  );
};
